import Vue from 'vue'
import outputTransformer from '@/transformers/catalog/warehouse/outputsRequest'

/**
 * @author jorge nuñez lópez <>
 *
 * Fetch outputs request 
 * @return {List}
 */

function urlParamsTransformer(opts) {
  return {
    warehouse: opts.warehouse,
    status: opts.status
  }
}
export default (opts) => {
  let config
  if(opts) {
    config = {
      params: urlParamsTransformer(opts)
    }
  }
  return Vue.$http.get(`iwarehouse/report/output-request/`, config)
    .then(({ data }) => {
      const dataTransformed = outputTransformer.fetchCollection(data)
      return dataTransformed
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchOutputRequests.js